import { atom } from 'jotai';

import { settingsRouteParamAtom } from './settingsModule.state';

export const $teamPermissionsFacilityId = settingsRouteParamAtom(
  ['/team-and-permissions/facilities/:facilityId'],
  'facilityId',
);

export type FacilityDetailsTab = 'roles' | 'users';

export const $facilityDetailsTab = atom<FacilityDetailsTab>('roles');

export interface CurrentFacilityData {
  id: string;
  name: string;
  address: string;
}

export const $currentFacility = atom<CurrentFacilityData | null>(null);

export const $facilityDetailsSelectedRoleId = atom<string | null>(null);

export const $facilityDetailsSelectedUserId = atom<string | null>(null);
